import { avecExigence, exigeBonCommande } from '../lib/bon-commande';
import { tr } from '../lib/i18n';
import { C } from '../theme/palette';
import { _inp } from './ui/Inputs.jsx';

/**
 * « N° de bon de commande du client » sur l'offre ou la facture.
 *
 * <p>Le numéro s'imprime en vue sous le titre du document envoyé. La case
 * dit, sur la fiche du client, qu'il l'exige toujours : la facture ne part
 * alors pas sans lui.
 *
 * @param {object} props propriétés
 * @param {string} [props.value] numéro saisi
 * @param {(v: string) => void} props.onChange reçoit le numéro
 * @param {object} [props.client] client choisi
 * @param {(fn: (p: object[]) => object[]) => void} [props.setClients] mise à jour des clients
 * @returns {import('react').ReactElement} le champ
 */
export function BonCommandeClient({ value, onChange, client, setClients }) {
  const exige = exigeBonCommande(client);
  const manque = exige && !String(value ?? '').trim();
  return (
    <div style={{ marginBottom: 10 }}>
      <div
        style={{
          fontSize: 9,
          fontWeight: 700,
          color: manque ? C.red : C.muted,
          marginBottom: 3,
          textTransform: 'uppercase',
          letterSpacing: 0.4,
        }}
      >
        🧾 {tr('N° de bon de commande du client')}
        {exige ? ' *' : ''}
      </div>
      <input
        aria-label={tr('N° de bon de commande du client')}
        value={value || ''}
        maxLength={60}
        placeholder={tr('ex. BC-2026-1187')}
        onChange={(e) => onChange(e.target.value)}
        style={{ ..._inp, ...(manque ? { border: '1px solid ' + C.red } : {}) }}
      />
      <div style={{ fontSize: 10, color: C.muted, marginTop: 4, lineHeight: 1.4 }}>
        {tr('Imprimé en vue sur le document envoyé : « Votre bon de commande : … »')}
      </div>
      {manque && (
        <div role="alert" style={{ fontSize: 10.5, color: C.red, fontWeight: 700, marginTop: 4 }}>
          ⚠{' '}
          {tr('Ce client exige un n° de bon de commande : sans lui, la facture ne sera pas payée.')}
        </div>
      )}
      {client && setClients && (
        <label
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 7,
            fontSize: 11,
            color: C.ink,
            marginTop: 6,
            cursor: 'pointer',
          }}
        >
          <input
            type="checkbox"
            checked={exige}
            onChange={(e) =>
              setClients((p) =>
                p.map((c) => (c.id === client.id ? avecExigence(c, e.target.checked) : c)),
              )
            }
          />
          {tr('Ce client exige toujours un n° de bon de commande')}
        </label>
      )}
    </div>
  );
}
